import { isToday } from 'date-fns'
import qs from 'qs'
import { useEffect } from 'react'

import commonRepo from '@/repository/common.repo'
import { customerMessengerService } from '@/utils/modules/CustomerMessenger/CustomerMessengerService'
import { datadogClient } from '@/utils/modules/datadog/datadogClient'
import { _mixpanelUtils } from '@/utils/trackings/_mixpanel'
import { mixpanelClient } from '@/utils/trackings/mixpanel'
import { convertAcademyAndTeacherToGlobalEventProperty } from '@/utils/trackings/schema/globalEventProperties.schema'
import { convertAcademyToUserProperties } from '@/utils/trackings/schema/userProperties.schema'

export const useDataTracking = () => {
  useEffect(() => {
    if (commonRepo.academy && commonRepo.user) {
      mixpanelClient.identify(commonRepo.academy.academyId)

      mixpanelClient.setGlobalEventProperty({
        ...convertAcademyAndTeacherToGlobalEventProperty({
          academy: commonRepo.academy,
          teacher: commonRepo.user,
        }),
        챗봇_켜기: customerMessengerService.enabled,
      })

      datadogClient.setGlobalContextProperty('academy', commonRepo.academy)
      datadogClient.setGlobalContextProperty('teacher', commonRepo.user)
      datadogClient.setGlobalContextProperty('챗봇켜기', customerMessengerService.enabled)

      mixpanelClient.setUserProperty({
        ...convertAcademyToUserProperties({
          academy: commonRepo.academy,
        }),
      })

      datadogClient.setUser({
        ...commonRepo.user,
        id: commonRepo.user.teacherId,
        userType: 'teacher',
        academyGroupId: commonRepo.academy.groupId,
      })

      if (commonRepo.academy.academyId) {
        datadogClient.setAccount({
          ...commonRepo.academy,
          id: commonRepo.academy.academyId,
          academyGroupId: commonRepo.academy.groupId,
        })
      }
    }
  }, [commonRepo.academy, commonRepo.user])

  useEffect(() => {
    const params: any = qs.parse(window.location.search, { ignoreQueryPrefix: true })

    if ('s' in params && typeof params.s === 'string') {
      params['당일접속여부'] = isToday(parseInt(params.s))
    }

    _mixpanelUtils.uiTrack('로그인화면_수동', params)
  }, [])
}
